import React from 'react';
import { Link } from 'react-router-dom';
import { VivahLogoIcon } from './VivahLogo';

export default function Footer() {
  const year = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer-wrapper">
      {/* Golden accent bar top */}
      <div className="footer-top-accent" />

      {/* Pre-footer Callout Banner */}
      <div className="footer-cta-banner">
        <div className="footer-cta-content">
          <div className="footer-cta-text">
            <span className="badge-light" style={{ background: 'rgba(247, 208, 112, 0.15)', color: '#F7D070', border: '1px solid rgba(247, 208, 112, 0.3)' }}>
              ✦ Personal Marriage Guidance ✦
            </span>
            <h3>Ready to Find Your Ideal Life Partner?</h3>
            <p>Consultant Laxmikant Timilsina handles every profile with utmost confidentiality and authentic Kundali matching.</p>
          </div>
          <div className="footer-cta-btns">
            <Link to="/consultation/register" className="btn btn-secondary">
              Register Profile →
            </Link>
            <a href="tel:9857074103" className="btn btn-tertiary">
              📞 Call Laxmikant (9857074103)
            </a>
          </div>
        </div>
      </div>

      <div className="footer-inner">
        {/* 4-column rich grid */}
        <div className="footer-grid">

          {/* Col 1: Brand & Royalty */}
          <div className="footer-col footer-col--brand">
            <div className="footer-brand-logo">
              <VivahLogoIcon size={46} />
              <div>
                <div className="footer-brand-name">Vivah Nepal</div>
                <div className="footer-brand-sub">Nepal's Premier Marriage Consultation</div>
              </div>
            </div>
            <p className="footer-brand-desc">
              Trusted by hundreds of families across Nepal. Personal matchmaking by 
              <strong> Laxmikant Timilsina</strong> (Yogikuti, Butwal) paired with royal catering and decor by 
              <strong> Krishna Khanal</strong>.
            </p>
            
            <div className="footer-trust-badge">
              <span className="footer-trust-icon">🛡️</span>
              <div>
                <strong>100% Confidential Guarantee</strong>
                <span>Photos &amp; Kundali shared only upon mutual consent.</span>
              </div>
            </div>

            <div className="footer-contact-pills" style={{ marginTop: '1.2rem' }}>
              <a href="tel:9857074103" className="footer-pill">
                <span>💍</span> Laxmikant: 9857074103
              </a>
              <a href="tel:9867155395" className="footer-pill">
                <span>🍽️</span> Krishna: 9867155395
              </a>
            </div>
          </div>

          {/* Col 2: Matrimony Services */}
          <div className="footer-col">
            <h4 className="footer-col-title">💍 Matrimony Portal</h4>
            <nav className="footer-nav-links">
              <Link to="/consultation">Browse Sample Matches</Link>
              <Link to="/consultation/register">Register Marriage Profile</Link>
              <Link to="/consultation/payment">Membership &amp; QR Payment</Link>
              <Link to="/consultation/profile">My Marriage Profile</Link>
              <Link to="/consultation/about">About Laxmikant Timilsina</Link>
            </nav>
          </div>

          {/* Col 3: Sabitri Catering & Decor */}
          <div className="footer-col">
            <h4 className="footer-col-title">🍽️ Catering &amp; Decor</h4>
            <nav className="footer-nav-links">
              <Link to="/catering">Sabitri Catering Overview</Link>
              <Link to="/catering/menu">Catering Menu &amp; Packages</Link>
              <Link to="/catering/quote">Request Catering Quote</Link>
              <Link to="/decor">Mandap Decor Catalog</Link>
              <Link to="/decor/quote">Custom Decor Quote</Link>
              <Link to="/decor/booking">Book Event Services</Link>
            </nav>
          </div>

          {/* Col 4: Contact & Offices */}
          <div className="footer-col">
            <h4 className="footer-col-title">📍 Offices &amp; Support</h4>
            <div className="footer-info-list">
              <div className="footer-info-item">
                <span className="footer-info-icon">📍</span>
                <div>
                  <strong>Headquarters</strong>
                  <span>Yogikuti, Butwal, Rupandehi, Nepal</span>
                </div>
              </div>
              <div className="footer-info-item">
                <span className="footer-info-icon">💍</span>
                <div>
                  <strong>Consultant Direct Line</strong>
                  <a href="tel:9857074103">Laxmikant Timilsina · 9857074103</a>
                </div>
              </div>
              <div className="footer-info-item">
                <span className="footer-info-icon">🍽️</span>
                <div>
                  <strong>Catering Manager</strong>
                  <a href="tel:9867155395">Krishna Khanal · 9867155395</a>
                </div>
              </div>
              <div className="footer-info-item">
                <span className="footer-info-icon">💻</span>
                <div>
                  <strong>Technical Development</strong>
                  <a href="https://pourkas.org" target="_blank" rel="noopener noreferrer">
                    Prakash Sharma Timilsina · pourkas.org
                  </a>
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '0.6rem', alignItems: 'center', marginTop: '0.8rem' }}>
              <Link to="/contact" className="footer-contact-btn">
                📍 View All Branch Offices →
              </Link>
              <button 
                onClick={scrollToTop} 
                className="footer-scroll-top-btn"
                title="Back to Top"
              >
                ↑ Top
              </button>
            </div>
          </div>
        </div>

        {/* Bottom copyright & attribution bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <span>© {year} Vivah Nepal — All Rights Reserved.</span>
            <span className="footer-bottom-sep">·</span>
            <span>Yogikuti, Butwal, Nepal</span>
            <span className="footer-bottom-sep">·</span>
            <span style={{ color: 'var(--wedding-gold)' }}>Authentic Nepal Matrimony</span>
          </div>
          <div className="footer-bottom-right">
            <span>Designed &amp; Managed by </span>
            <a href="https://pourkas.org" target="_blank" rel="noopener noreferrer">
              Prakash Sharma Timilsina (pourkas.org)
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
